module.exports = __webpack_public_path__ + "img/title2.df829e69.png";